module.exports = __webpack_public_path__ + "img/113.9e41a922.jpg";